import { render } from "./LunchUpdate.vue?vue&type=template&id=61b3f388"
import script from "./LunchUpdate.vue?vue&type=script&lang=js"
export * from "./LunchUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__